
import React, { useRef, useState } from 'react';
import axios from 'axios';
import hostlink from '../Hostlink/hostlink';
import * as XLSX from 'xlsx';
import {
    PDFDownloadLink,
    Document,
    Page,
    Text,
    View,
    StyleSheet
} from '@react-pdf/renderer';

const Rpt_CuttingReport = () => {

    const usershopid = localStorage.getItem('MYPCKARTUSER')
        ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id
        : '0';

    const today = new Date();

    const [fromdate, setFromdate] = useState(
        "2024-01-01"
    );

    const [todate, setTodate] = useState(
        today.toISOString().split('T')[0]
    );

    const [lotno, setLotno] = useState('');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const tableRef = useRef(null);


    // =====================================================
    // LOAD DATA
    // =====================================================

    const loaddata = async () => {

        if (!fromdate || !todate) {
            alert('Please select From Date and To Date');
            return;
        }

        if (fromdate > todate) {
            alert('From Date cannot be greater than To Date');
            return;
        }

        try {

            setLoading(true);

            const response = await axios.get(
                `${hostlink}/PurchaseMasviewrpt/1/${usershopid}/${fromdate}/${todate}`
            );

            let result = response.data || [];


            // LOT NO SEARCH

            if (lotno.trim() !== '') {

                const searchLot = lotno
                    .trim()
                    .toLowerCase();

                result = result.filter((res) => {

                    const currentLot = String(
                        res.billno || ''
                    ).toLowerCase();

                    return currentLot.includes(searchLot);

                });

            }


            setData(result);

        } catch (error) {

            console.log('Data Not Found...', error);

            setData([]);

        } finally {

            setLoading(false);

        }
    };


    // =====================================================
    // CLEAR LOT
    // =====================================================

    const clearLot = () => {
        setLotno('');
    };


    // =====================================================
    // EXCEL
    // =====================================================

    const exportToExcel = () => {

        if (!tableRef.current || data.length === 0) {
            return;
        }

        const ws = XLSX.utils.table_to_sheet(
            tableRef.current
        );

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            'Cutting Report'
        );

        XLSX.writeFile(
            wb,
            'Cutting Report.xlsx'
        );
    };


    // =====================================================
    // TOTALS
    // =====================================================

    const totalMtr = data.reduce(
        (total, res) =>
            total + Number(res.mtr || 0) * -1,
        0
    );

    const totalRoll = data.reduce(
        (total, res) =>
            total + Number(res.roll || 0) * -1,
        0
    );

    const totalPcs = data.reduce(
        (total, res) =>
            total + Number(res.pcs || 0),
        0
    );


    // =====================================================
    // DATE FORMAT
    // =====================================================

    const formatDate = (date) => {

        if (!date) {
            return '-';
        }

        return new Date(date).toLocaleDateString(
            'en-GB',
            {
                day: '2-digit',
                month: '2-digit',
                year: '2-digit'
            }
        );
    };


    return (

        <div
            className="container-fluid py-3"
            style={{
                background: '#f5f7fb',
                minHeight: '100vh'
            }}
        >


            {/* =================================================
                HEADER
            ================================================= */}

            <div className="d-flex justify-content-between align-items-center mb-3">

                <div>

                    <div
                        className="d-flex align-items-center"
                        style={{ gap: '12px' }}
                    >

                        <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                width: '45px',
                                height: '45px',
                                borderRadius: '12px',
                                background: '#0d6efd',
                                color: '#fff',
                                fontSize: '20px',
                                boxShadow: '0 5px 15px rgba(13,110,253,0.25)'
                            }}
                        >
                            <i className="fa-solid fa-scissors"></i>
                        </div>

                        <div>

                            <h4
                                className="mb-0 fw-bold text-dark"
                            >
                                Cutting Report
                            </h4>

                            <small className="text-muted">
                                Cutting & production summary
                            </small>

                        </div>

                    </div>

                </div>


                <div>

                    <span
                        className="badge rounded-pill bg-white text-dark border px-3 py-2"
                    >
                        <i className="fa-regular fa-calendar me-1"></i>

                        {fromdate} → {todate}

                    </span>

                </div>

            </div>


            {/* =================================================
                FILTER CARD
            ================================================= */}

            <div
                className="card border-0 mb-3"
                style={{
                    borderRadius: '16px',
                    boxShadow: '0 5px 25px rgba(0,0,0,0.07)'
                }}
            >

                <div className="card-body p-3">

                    <div className="row g-3 align-items-end">


                        {/* FROM DATE */}

                        <div className="col-xl-2 col-lg-3 col-md-6">

                            <label
                                className="form-label fw-semibold text-secondary"
                            >
                                <i className="fa-regular fa-calendar me-1"></i>
                                From Date
                            </label>

                            <input
                                type="date"
                                value={fromdate}
                                max={todate}
                                onChange={(e) =>
                                    setFromdate(e.target.value)
                                }
                                className="form-control"
                            />

                        </div>


                        {/* TO DATE */}

                        <div className="col-xl-2 col-lg-3 col-md-6">

                            <label
                                className="form-label fw-semibold text-secondary"
                            >
                                <i className="fa-regular fa-calendar me-1"></i>
                                To Date
                            </label>

                            <input
                                type="date"
                                value={todate}
                                min={fromdate}
                                onChange={(e) =>
                                    setTodate(e.target.value)
                                }
                                className="form-control"
                            />

                        </div>


                        {/* LOT NO */}

                        <div className="col-xl-3 col-lg-4 col-md-8">

                            <label
                                className="form-label fw-semibold text-secondary"
                            >
                                <i className="fa-solid fa-magnifying-glass me-1"></i>
                                Search Lot No
                            </label>

                            <div className="input-group">

                                <input
                                    type="text"
                                    value={lotno}
                                    placeholder="Enter Lot No..."
                                    className="form-control"
                                    onChange={(e) =>
                                        setLotno(e.target.value)
                                    }
                                    onKeyDown={(e) => {

                                        if (e.key === 'Enter') {
                                            loaddata();
                                        }

                                    }}
                                />

                                {lotno !== '' && (

                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={clearLot}
                                    >

                                        <i className="fa-solid fa-xmark"></i>

                                    </button>

                                )}

                            </div>

                        </div>


                        {/* SHOW */}

                        <div className="col-xl-2 col-lg-2 col-md-4">

                            <button
                                type="button"
                                onClick={loaddata}
                                disabled={loading}
                                className="btn btn-primary w-100"
                                style={{
                                    height: '38px',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 12px rgba(13,110,253,0.20)'
                                }}
                            >

                                {loading ? (

                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                        ></span>

                                        Loading...
                                    </>

                                ) : (

                                    <>
                                        <i className="fa-solid fa-magnifying-glass me-2"></i>
                                        Show Report
                                    </>

                                )}

                            </button>

                        </div>


                        {/* EXPORT */}

                        <div className="col-xl-3 col-lg-12">

                            <div className="d-flex gap-2">

                                <button
                                    type="button"
                                    onClick={exportToExcel}
                                    disabled={data.length === 0}
                                    className="btn btn-outline-success flex-fill"
                                    style={{
                                        height: '38px',
                                        borderRadius: '8px'
                                    }}
                                >

                                    <i className="fa-solid fa-file-excel me-1"></i>

                                    Excel

                                </button>


                                <PDFDownloadLink
                                    document={
                                        <PDFDocument
                                            data={data}
                                            fromdate={fromdate}
                                            todate={todate}
                                        />
                                    }
                                    fileName="Cutting Report.pdf"
                                    className="flex-fill"
                                >

                                    {({ loading: pdfLoading }) => (

                                        <button
                                            type="button"
                                            disabled={
                                                data.length === 0 ||
                                                pdfLoading
                                            }
                                            className="btn btn-outline-danger w-100"
                                            style={{
                                                height: '38px',
                                                borderRadius: '8px'
                                            }}
                                        >

                                            <i className="fa-solid fa-file-pdf me-1"></i>

                                            {pdfLoading
                                                ? 'Loading'
                                                : 'PDF'
                                            }

                                        </button>

                                    )}

                                </PDFDownloadLink>

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                SUMMARY CARDS
            ================================================= */}

            <div className="row g-3 mb-3">


                {/* RECORDS */}

                <div className="col-xl-3 col-md-6">

                    <div
                        className="card border-0 h-100"
                        style={{
                            borderRadius: '14px',
                            boxShadow: '0 4px 18px rgba(0,0,0,0.06)'
                        }}
                    >

                        <div className="card-body">

                            <div className="d-flex justify-content-between">

                                <div>

                                    <small className="text-muted">
                                        Total Records
                                    </small>

                                    <h4 className="fw-bold mb-0">
                                        {data.length}
                                    </h4>

                                </div>

                                <div
                                    className="d-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary"
                                    style={{
                                        width: '42px',
                                        height: '42px',
                                        borderRadius: '10px'
                                    }}
                                >

                                    <i className="fa-solid fa-list"></i>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>


                {/* MTR */}

                <div className="col-xl-3 col-md-6">

                    <div
                        className="card border-0 h-100"
                        style={{
                            borderRadius: '14px',
                            boxShadow: '0 4px 18px rgba(0,0,0,0.06)'
                        }}
                    >

                        <div className="card-body">

                            <div className="d-flex justify-content-between">

                                <div>

                                    <small className="text-muted">
                                        Total Mtr
                                    </small>

                                    <h4 className="fw-bold mb-0">
                                        {totalMtr}
                                    </h4>

                                </div>

                                <div
                                    className="d-flex align-items-center justify-content-center bg-info bg-opacity-10 text-info"
                                    style={{
                                        width: '42px',
                                        height: '42px',
                                        borderRadius: '10px'
                                    }}
                                >

                                    <i className="fa-solid fa-ruler-horizontal"></i>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>


                {/* ROLL */}

                <div className="col-xl-3 col-md-6">

                    <div
                        className="card border-0 h-100"
                        style={{
                            borderRadius: '14px',
                            boxShadow: '0 4px 18px rgba(0,0,0,0.06)'
                        }}
                    >

                        <div className="card-body">

                            <div className="d-flex justify-content-between">

                                <div>

                                    <small className="text-muted">
                                        Total Roll
                                    </small>

                                    <h4 className="fw-bold mb-0">
                                        {totalRoll}
                                    </h4>

                                </div>

                                <div
                                    className="d-flex align-items-center justify-content-center bg-warning bg-opacity-10 text-warning"
                                    style={{
                                        width: '42px',
                                        height: '42px',
                                        borderRadius: '10px'
                                    }}
                                >

                                    <i className="fa-solid fa-scroll"></i>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>


                {/* PCS */}

                <div className="col-xl-3 col-md-6">

                    <div
                        className="card border-0 h-100"
                        style={{
                            borderRadius: '14px',
                            boxShadow: '0 4px 18px rgba(0,0,0,0.06)'
                        }}
                    >

                        <div className="card-body">

                            <div className="d-flex justify-content-between">

                                <div>

                                    <small className="text-muted">
                                        Total Pcs
                                    </small>

                                    <h4 className="fw-bold mb-0">
                                        {totalPcs}
                                    </h4>

                                </div>

                                <div
                                    className="d-flex align-items-center justify-content-center bg-success bg-opacity-10 text-success"
                                    style={{
                                        width: '42px',
                                        height: '42px',
                                        borderRadius: '10px'
                                    }}
                                >

                                    <i className="fa-solid fa-boxes-stacked"></i>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                REPORT TABLE CARD
            ================================================= */}

            <div
                className="card border-0"
                style={{
                    borderRadius: '16px',
                    boxShadow: '0 5px 25px rgba(0,0,0,0.07)'
                }}
            >

                <div className="card-body p-0">


                    {/* TABLE HEADER */}

                    <div
                        className="d-flex justify-content-between align-items-center px-3 py-3 border-bottom"
                    >

                        <div>

                            <h6 className="fw-bold mb-0">

                                <i className="fa-solid fa-table me-2 text-primary"></i>

                                Cutting Details

                            </h6>

                        </div>


                        <div>

                            {lotno !== '' && (

                                <span className="badge bg-primary-subtle text-primary px-3 py-2">

                                    Lot: {lotno}

                                </span>

                            )}

                        </div>

                    </div>


                    {/* TABLE */}

                    <div
                        className="table-responsive"
                        style={{
                            maxHeight: '600px'
                        }}
                    >

                        <table
                            className="table table-hover align-middle mb-0"
                            ref={tableRef}
                        >

                            <thead
                                className="table-light"
                                style={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 1
                                }}
                            >

                                <tr>

                                    <th className="text-start">
                                        Lot No
                                    </th>

                                    <th className="text-start">
                                        Date
                                    </th>

                                    <th className="text-start">
                                        Fabricator
                                    </th>

                                    <th className="text-start">
                                        Sort No
                                    </th>

                                    <th className="text-end">
                                        Mtr
                                    </th>

                                    <th className="text-end">
                                        Roll
                                    </th>

                                    <th className="text-end">
                                        Avg
                                    </th>

                                    <th className="text-end">
                                        Style
                                    </th>

                                    <th className="text-end">
                                        Size
                                    </th>

                                    <th className="text-end">
                                        Pcs
                                    </th>

                                </tr>

                            </thead>


                            <tbody>


                                {data.length === 0 ? (

                                    <tr>

                                        <td
                                            colSpan="10"
                                            className="text-center py-5"
                                        >

                                            <div className="text-muted">

                                                <i
                                                    className="fa-solid fa-folder-open"
                                                    style={{
                                                        fontSize: '35px'
                                                    }}
                                                ></i>

                                                <div className="mt-2 fw-semibold">
                                                    No data found
                                                </div>

                                                <small>
                                                    Select dates or enter a Lot No and click Show Report
                                                </small>

                                            </div>

                                        </td>

                                    </tr>

                                ) : (

                                    data.map((res, x) => {

                                        const isDuplicate =
                                            x > 0 &&
                                            res.billno ===
                                            data[x - 1].billno;

                                        return (

                                            <tr key={x}>

                                                <td className="text-start fw-semibold">

                                                    {isDuplicate
                                                        ? ''
                                                        : res.billno}

                                                </td>


                                                <td className="text-start">

                                                    {isDuplicate
                                                        ? ''
                                                        : formatDate(
                                                            res.billdate
                                                        )}

                                                </td>


                                                <td className="text-start">

                                                    {isDuplicate
                                                        ? ''
                                                        : res.fabname}

                                                </td>


                                                <td className="text-start">

                                                    {res.sortno}

                                                </td>


                                                <td className="text-end">

                                                    {Number(
                                                        res.mtr || 0
                                                    ) * -1}

                                                </td>


                                                <td className="text-end">

                                                    {Number(
                                                        res.roll || 0
                                                    ) * -1}

                                                </td>


                                                <td className="text-end">

                                                    {res.avg}

                                                </td>


                                                <td className="text-end">

                                                    {res.style}

                                                </td>


                                                <td className="text-end">

                                                    {res.size}

                                                </td>


                                                <td className="text-end fw-semibold">

                                                    {res.pcs}

                                                </td>

                                            </tr>

                                        );

                                    })

                                )}


                                {/* TOTAL */}

                                {data.length > 0 && (

                                    <tr
                                        className="table-primary fw-bold"
                                        style={{
                                            position: 'sticky',
                                            bottom: 0
                                        }}
                                    >

                                        <td></td>

                                        <td></td>

                                        <td></td>

                                        <td className="text-end">
                                            Total :
                                        </td>

                                        <td className="text-end">
                                            {totalMtr}
                                        </td>

                                        <td className="text-end">
                                            {totalRoll}
                                        </td>

                                        <td></td>

                                        <td></td>

                                        <td></td>

                                        <td className="text-end">
                                            {totalPcs}
                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    );
};


// =====================================================
// PDF DOCUMENT
// =====================================================

const PDFDocument = ({
    data,
    fromdate,
    todate
}) => {

    return (

        <Document>

            <Page
                orientation="landscape"
                size="A4"
            >

                <View style={styles.container}>

                    <Text style={styles.title}>
                        Cutting Report
                    </Text>

                    <Text style={styles.subtitle}>
                        From : {fromdate} To : {todate}
                    </Text>


                    <View style={styles.table}>

                        <View style={styles.tableRow}>

                            <Text style={styles.headerCell}>
                                Lot No
                            </Text>

                            <Text style={styles.headerCell}>
                                Date
                            </Text>

                            <Text style={styles.headerCell}>
                                Fabricator
                            </Text>

                            <Text style={styles.headerCell}>
                                Sort No
                            </Text>

                            <Text style={styles.headerCell}>
                                Mtr
                            </Text>

                            <Text style={styles.headerCell}>
                                Roll
                            </Text>

                            <Text style={styles.headerCell}>
                                Avg
                            </Text>

                            <Text style={styles.headerCell}>
                                Style
                            </Text>

                            <Text style={styles.headerCell}>
                                Size
                            </Text>

                            <Text style={styles.headerCell}>
                                Pcs
                            </Text>

                        </View>


                        {data.map((res, x) => {

                            const isDuplicate =
                                x > 0 &&
                                res.billno ===
                                data[x - 1].billno;

                            return (

                                <View
                                    key={x}
                                    style={styles.tableRow}
                                >

                                    <Text style={styles.cell}>
                                        {isDuplicate
                                            ? ''
                                            : res.billno}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {isDuplicate
                                            ? ''
                                            : res.billdate
                                                ? new Date(
                                                    res.billdate
                                                ).toLocaleDateString(
                                                    'en-GB'
                                                )
                                                : '-'}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {isDuplicate
                                            ? ''
                                            : res.fabname}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.sortno}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {Number(res.mtr || 0) * -1}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {Number(res.roll || 0) * -1}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.avg}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.style}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.size}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.pcs}
                                    </Text>

                                </View>

                            );

                        })}


                        <View style={styles.tableRow}>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}>
                                Total :
                            </Text>

                            <Text style={styles.cell}>
                                {data.reduce(
                                    (total, res) =>
                                        total +
                                        Number(res.mtr || 0) * -1,
                                    0
                                )}
                            </Text>

                            <Text style={styles.cell}>
                                {data.reduce(
                                    (total, res) =>
                                        total +
                                        Number(res.roll || 0) * -1,
                                    0
                                )}
                            </Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}></Text>

                            <Text style={styles.cell}>
                                {data.reduce(
                                    (total, res) =>
                                        total +
                                        Number(res.pcs || 0),
                                    0
                                )}
                            </Text>

                        </View>

                    </View>

                </View>

            </Page>

        </Document>

    );
};


// =====================================================
// PDF STYLES
// =====================================================

const styles = StyleSheet.create({

    container: {
        padding: 20
    },

    title: {
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 8
    },

    subtitle: {
        fontSize: 10,
        textAlign: 'center',
        marginBottom: 18
    },

    table: {
        display: 'table',
        width: '100%'
    },

    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#cccccc'
    },

    headerCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 5,
        flex: 1,
        textAlign: 'center'
    },

    cell: {
        fontSize: 8,
        padding: 5,
        flex: 1,
        textAlign: 'center'
    }

});


export default Rpt_CuttingReport;

